var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-preparation" },
    [
      _vm.moduleListUploadSelect.length
        ? _c("p", { staticClass: "data-preparation-tips upload-files-tips" }, [
            _vm._v("\n    选择信息，生成资料清单\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.moduleListUploadSelect, function(column) {
        return _c(
          "div",
          { key: column.columnId, staticClass: "module-radio-group" },
          [
            _c("span", [_vm._v(_vm._s(column.keyLabel) + ":")]),
            _vm._v(" "),
            _c(
              "RadioGroup",
              {
                model: {
                  value: column.value,
                  callback: function($$v) {
                    _vm.$set(column, "value", $$v)
                  },
                  expression: "column.value"
                }
              },
              _vm._l(column.info.groups, function(item) {
                return _c(
                  "Radio",
                  { key: item.value, attrs: { label: item.value } },
                  [_vm._v(_vm._s(item.label))]
                )
              }),
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("p", { staticClass: "data-preparation-tips upload-files-tips" }, [
        _vm._v("\n    需要以下文件"),
        _c(
          "span",
          { staticClass: "download-btn", on: { click: _vm.downloadHandle } },
          [
            _c("img", {
              attrs: { src: require("@/assets/images/common/downloadIcon.png") }
            }),
            _vm._v("下载资料清单")
          ]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.moduleListUpload, function(list) {
        return _c(
          "table",
          { key: list.moduleId, staticClass: "data-preparation-list" },
          [
            _vm._l(list.uploadArr, function(item, index) {
              return [
                _c("tr", { key: index }, [
                  index == 0 && _vm.getUploadArrLen(list.uploadArr)
                    ? _c(
                        "td",
                        {
                          staticClass: "upload-files-parent-label",
                          attrs: { rowspan: list.uploadArr.length }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(list.moduleName) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.isShow
                    ? _c(
                        "td",
                        {
                          staticClass: "upload-files-item",
                          attrs: { width: "200" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.keyLabel) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.isShow
                    ? _c("td", { staticClass: "upload-files-item" }, [
                        _c("p", { staticClass: "upload-remind-message" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.isNeed ? "必填" : "选填") +
                              " "
                          ),
                          item.remindMessage
                            ? _c("span", [
                                _vm._v("/ " + _vm._s(item.remindMessage))
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.isShow
                    ? _c("td", { attrs: { width: "200" } }, [
                        item.fileModelUrl
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: item.fileModelUrl,
                                  target: "_black"
                                }
                              },
                              [_vm._v("查看示例")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ]
            })
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-508ef4be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508ef4be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/dataPreparation.vue
// module id = null
// module chunks = 